var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMentors({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5732 23.3145V20.8145C18.5732 19.4884 18.0465 18.2166 17.1088 17.2789C16.1711 16.3412 14.8993 15.8145 13.5732 15.8145H6.07324C4.74716 15.8145 3.47539 16.3412 2.53771 17.2789C1.60003 18.2166 1.07324 19.4884 1.07324 20.8145V23.3145M18.5732 0.974453C19.6454 1.25242 20.595 1.87853 21.2728 2.75453C21.9507 3.63053 22.3185 4.70681 22.3185 5.81445C22.3185 6.92209 21.9507 7.99838 21.2728 8.87438C20.595 9.75037 19.6454 10.3765 18.5732 10.6545M26.0732 23.3145V20.8145C26.0724 19.7066 25.7037 18.6304 25.0249 17.7548C24.3462 16.8793 23.3959 16.2539 22.3232 15.977M14.8232 5.81445C14.8232 8.57588 12.5847 10.8145 9.82324 10.8145C7.06182 10.8145 4.82324 8.57588 4.82324 5.81445C4.82324 3.05303 7.06182 0.814453 9.82324 0.814453C12.5847 0.814453 14.8232 3.05303 14.8232 5.81445Z",
    stroke: "#08AE9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMentors);
export default __webpack_public_path__ + "static/media/activeMentors.1b5ff5739467888597d37fbf7990cd4f.svg";
export { ForwardRef as ReactComponent };